import React from 'react';
import ComponentWrapper from '../EntrypointWrapper';
import DesktopNavbar from './components/DesktopNavbar'
import MobileNavbar from './components/MobileNavbar'

const Navbar = (props) => {
	const mobileNav = (e, id) => {
		e.preventDefault();
		var x = document.getElementById(id);
		x.classList.toggle('hidden')
	}
	if (props.env === "staging") {

		return (
			<ComponentWrapper
				breakpointContainer={false}
				bgColor={"white"}
			>

				<div className="flex w-[94%] mx-auto justify-between items-center h-[9rem]">
					<a href="https://www.intel.com/content/www/us/en/events/on-event-series/innovation.html" className="w-[26.1rem] h-[3.1rem]">
						<img className="mr-auto  " src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/intel-logo_1659627973043001tuZv.png" />
					</a>
					<nav className="text-[#3F1EDD] hidden lg:block">
						<DesktopNavbar />
					</nav>
					<h1 className=" w-1/12 text-right text-[#00A3F6] hover:underline cursor-pointer">
						<a href="https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/portal" className="hidden lg:block text-[1.8rem]" >My Portal</a>
						<a onClick={(e) => mobileNav(e, 'mobileNav')} href="#" className="block lg:hidden " >
							<img id='humburgerIcon' className="ml-auto" src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/intel-humbarger_165962799215700192K5.png" />
						</a>
						<div id="mobileNav" className="hidden lg:hidden">
							<MobileNavbar />
						</div>
					</h1>
				</div>
			</ComponentWrapper>
		)
	}
	else if (props.env === "prod") {
		return (
			<ComponentWrapper
				breakpointContainer={false}
				bgColor={"white"}
			>

				<div className="flex w-[94%] mx-auto justify-between items-center h-[9rem]">
					<a href="https://www.intel.com/content/www/us/en/events/on-event-series/innovation.html" className="w-[26.1rem] h-[3.1rem]">
						<img className="mr-auto  " src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/intel-logo_1659627973043001tuZv.png" />
					</a>
					<nav className="text-[#3F1EDD] hidden lg:block">
						<DesktopNavbar />
					</nav>
					<h1 className=" w-1/12 text-right text-[#00A3F6] hover:underline cursor-pointer">
						<a href="https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/portal" className="navBar-Portal hidden lg:block text-[1.8rem]" >My Portal</a>
						<a onClick={(e) => mobileNav(e, 'mobileNav')} href="#" className="block lg:hidden " >
							<img id='humburgerIcon' className="ml-auto" src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/intel-humbarger_165962799215700192K5.png" />
						</a>
						<div id="mobileNav" className="hidden lg:hidden">
							<MobileNavbar />
						</div>
					</h1>
				</div>
			</ComponentWrapper>
		)
	}
}

export default Navbar;
